import React from "react";
import { useTranslation } from "react-i18next";

import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import { styled } from "@mui/material/styles";
import { Colors } from "@/theme";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: Colors.TABLE_HEADER,
    color: Colors.GRAY_DARK,
    fontSize: 18,
  },
}));

const TableHeaderComponent = () => {
  const { t } = useTranslation();
  const headerCells = [
    {
      id: "brand",
      label: t("manage_price_screen.brand"),
      width: "13%",
      align: "center",
    },
    {
      id: "site_id",
      label: t("manage_price_screen.site_id"),
      width: "15%",
      align: "left",
    },
    {
      id: "site_name",
      label: t("manage_price_screen.site_name"),
      width: "15%",
      align: "left",
    },
    {
      id: "address",
      label: t("manage_price_screen.address"),
      width: "27%",
      align: "left",
    },
    {
      id: "prices",
      label: t("manage_price_screen.prices"),
      width: "30%",
      align: "left",
    },
  ];
  return (
    <TableHead>
      <TableRow>
        {headerCells.map((cell) => (
          <StyledTableCell
            key={cell.id}
            sx={{ width: cell.width }}
            align={cell.align}
          >
            {cell.label}
          </StyledTableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

export default TableHeaderComponent;
